import React from "react";
import { useParams } from "react-router-dom";
import storeData from "../data/storeData.json";
import "../style/CategoryCoupons.css";

const imageMap = {
  "../assets/nykaa.png": require("../assets/nykaa.png"),
  "../assets/airindia.png": require("../assets/airindia.png"),
  "../assets/dell.png": require("../assets/dell.png"),
  "../assets/ajio.png": require("../assets/ajio.png"),
  "../assets/myntra.png": require("../assets/myntra.png"),
  "../assets/uber.png": require("../assets/uber.png"),
  "../assets/amazon.png": require("../assets/amazon.png"),
  "../assets/makemytrip.png": require("../assets/makemytrip.png"),
  "../assets/udemy.png": require("../assets/udemy.png"),
  "../assets/bigrock.png": require("../assets/bigrock.png"),
  "../assets/samsung.png": require("../assets/samsung.png"),
  "../assets/flipkart.png": require("../assets/flipkart.png"),
  "../assets/snapdeal.png": require("../assets/snapdeal.png"),
  "../assets/lenovo.png": require("../assets/lenovo.png"),
  "../assets/shoppers.png": require("../assets/shoppers.png"),
  "../assets/zivame.png": require("../assets/zivame.png"),
  "../assets/apple.png": require("../assets/apple.png"),
  "../assets/hp.png": require("../assets/hp.png"),
  "../assets/oneplus.png": require("../assets/oneplus.png"),
  "../assets/google.png": require("../assets/google.png"),
  "../assets/logitech.png": require("../assets/logitech.png"),
  "../assets/microsoft.png": require("../assets/microsoft.png"),
  "../assets/h&m.png": require("../assets/h&m.png"),
  "../assets/zara.png": require("../assets/zara.png"),
  "../assets/tommy.png": require("../assets/tommy.png"),
  "../assets/whirpool.png": require("../assets/whirpool.png"),
  "../assets/decathlon.png": require("../assets/decathlon.png"),
  "../assets/lifestyle.png": require("../assets/lifestyle.png"),
  "../assets/allen.png": require("../assets/allen.png"),
  "../assets/unitedcolor.png": require("../assets/unitedcolor.png"),
  "../assets/calvin.png": require("../assets/calvin.png"),
  "../assets/markandspencer.png": require("../assets/markandspencer.png"),
  "../assets/veromoda.png": require("../assets/veromoda.png"),
  "../assets/urban.png": require("../assets/urban.png"),
  "../assets/croma.png": require("../assets/croma.png"),
  "../assets/reliance.png": require("../assets/reliance.png"),
  "../assets/booking.png": require("../assets/booking.png"),
  "../assets/xiaomi.png": require("../assets/xiaomi.png"),
  "../assets/realme.png": require("../assets/realme.png"),
  "../assets/lg.png": require("../assets/lg.png"),
  "../assets/bosch.png": require("../assets/bosch.png"),
  "../assets/kama.png": require("../assets/kama.png"),
  "../assets/forestessential.png": require("../assets/forestessential.png"),
    "../assets/mamaearth.png": require("../assets/mamaearth.png"),
        "../assets/firstcry.png": require("../assets/firstcry.png"),
        "../assets/naturesbasket.png": require("../assets/naturesbasket.png"),
        "../assets/dominos.png": require("../assets/dominos.png"),
        "../assets/starbucks.png": require("../assets/starbucks.png"),
        "../assets/cliq.png": require("../assets/cliq.png"),
                "../assets/paytm.png": require("../assets/paytm.png"),
                "../assets/googlepay.png": require("../assets/googlepay.png"),
                "../assets/phonepe.png": require("../assets/phonepe.png"),
                "../assets/mcd.png": require("../assets/mcd.png"),
                "../assets/burgerking.png": require("../assets/burgerking.png"),
                "../assets/redbus.png": require("../assets/redbus.png"),
                "../assets/goibibo.png": require("../assets/goibibo.png"),
                "../assets/yatra.png": require("../assets/yatra.png"),
"../assets/easemytrip.png": require("../assets/easemytrip.png"),
"../assets/peterengland.png": require("../assets/peterengland.png"),
"../assets/jacnandjones.png": require("../assets/jacnandjones.png"),
"../assets/only.png": require("../assets/only.png"),
"../assets/levis.png": require("../assets/levis.png"),
"../assets/wrangler.png": require("../assets/wrangler.png"),
"../assets/leecooper.png": require("../assets/leecooper.png"),
"../assets/bookmyshow.png": require("../assets/bookmyshow.png"),
"../assets/1mg.png": require("../assets/1mg.png"),
"../assets/lenskart.png": require("../assets/lenskart.png"),
"../assets/prestige.png": require("../assets/prestige.png"),
"../assets/hawkins.png": require("../assets/hawkins.png"),
"../assets/pigeon.png": require("../assets/pigeon.png"),
"../assets/netmeds.png": require("../assets/netmeds.png"),
"../assets/bluestone.png": require("../assets/bluestone.png"),
"../assets/caratlane.png": require("../assets/caratlane.png"),
"../assets/melorra.png": require("../assets/melorra.png"),
"../assets/swiggy.png": require("../assets/swiggy.png"),
"../assets/zomato.png": require("../assets/zomato.png"),
"../assets/netflix.png": require("../assets/netflix.png"),
"../assets/godaddy.png": require("../assets/godaddy.png"),
"../assets/hostinger.png": require("../assets/hostinger.png"),
"../assets/boat.png": require("../assets/boat.png"),
"../assets/meesho.png": require("../assets/meesho.png"),
"../assets/blinkit.png": require("../assets/blinkit.png"),
"../assets/jiomart.png": require("../assets/jiomart.png"),
"../assets/hotstar.png": require("../assets/hotstar.png"),
"../assets/biba.png": require("../assets/biba.png"),
"../assets/wforwoman.png": require("../assets/wforwoman.png"),
"../assets/fabindia.png": require("../assets/fabindia.png"),
"../assets/pizzahut.png": require("../assets/pizzahut.png"),
"../assets/kfc.png": require("../assets/kfc.png"),
"../assets/subway.png": require("../assets/subway.png"),
"../assets/cleartrip.png": require("../assets/cleartrip.png"),
"../assets/louis.png": require("../assets/louis.png"),
"../assets/arrow.png": require("../assets/arrow.png"),
"../assets/pepperfry.png": require("../assets/pepperfry.png"),
"../assets/urbanladder.png": require("../assets/urbanladder.png"),
"../assets/homecentre.png": require("../assets/homecentre.png"),
"../assets/godrej.png": require("../assets/godrej.png"),
"../assets/dmart.png": require("../assets/dmart.png"),
"../assets/bigbasket.png": require("../assets/bigbasket.png"),
"../assets/bodyshop.png": require("../assets/bodyshop.png"),
"../assets/loreal.png": require("../assets/loreal.png"),
"../assets/pharmeasy.png": require("../assets/pharmeasy.png"),
"../assets/apollo.png": require("../assets/apollo.png"),
"../assets/medlife.png": require("../assets/medlife.png"),
"../assets/wakefit.png": require("../assets/wakefit.png"),
"../assets/oyo.png": require("../assets/oyo.png"),
"../assets/sugar.png": require("../assets/sugar.png"),
"../assets/lakme.png": require("../assets/lakme.png"),
"../assets/licious.png": require("../assets/licious.png"),
"../assets/spotify.png": require("../assets/spotify.png"),
"../assets/gaana.png": require("../assets/gaana.png"),
"../assets/jiosaavn.png": require("../assets/jiosaavn.png"),
"../assets/minimalist.png": require("../assets/minimalist.png"),
"../assets/healthkart.png": require("../assets/healthkart.png"),



};

export default function CategoryCoupons() {
  const { categoryName } = useParams();

  // Normalize the categoryName to lowercase for matching
  const normalizedCategory = categoryName.toLowerCase();

  // Find all stores containing this category
  const categoryStores = Object.entries(storeData)
    .filter(([_, store]) =>
      store.categories.some((cat) => cat.toLowerCase() === normalizedCategory)
    )
    .map(([storeKey, store]) => ({
      id: storeKey,
      ...store,
    }));

  if (categoryStores.length === 0) {
    return <h2 style={{ textAlign: "center" }}>Category not found</h2>;
  }

  return (
    <div className="coupon-page">
      <div className="coupon-header">
        <h1>
          {normalizedCategory.charAt(0).toUpperCase() +
            normalizedCategory.slice(1)}
        </h1>
        <p>
          Found {categoryStores.length} stores with coupons for{" "}
          {normalizedCategory}.
        </p>
      </div>

      {categoryStores.map((store, idx) => (
        <div key={idx} className="coupon-card">
          <div className="store-header">
            <img
              src={imageMap[store.logo]}
              alt={store.title}
              className="store-logo"
            />
            <h3>{store.title}</h3>
          </div>

          <p>
            Coupons Available: <strong>{store.coupons?.length || 0}</strong>
          </p>

          <div className="store-coupons">
            {store.coupons?.map((coupon, cIdx) => (
              <div key={cIdx} className="coupon-item">
                <h4>{coupon.discount}</h4>
                <p>{coupon.description}</p>
                <a
                  href={coupon.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="coupon-link"
                >
                  Get Deal
                </a>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
